import React from 'react';

export const Badge = ({ type, children }) => {
  const getColor = (t) => {
    if (t === 'hot') return 'danger';
    if (t === 'favorite') return 'warning';
    if (t === 'verified') return 'success';
    if (t === 'suspended') return 'danger';
    if (t === 'public') return 'info';
    return 'secondary';
  };

  return (
    <span className={'badge bg-' + getColor(type) + ' me-1'}>
      {children}
    </span>
  );
};
